/* Armorwake theme JS */
(function () {
  // Product gallery thumbnails
  function initGallery(scope) {
    var main = scope.querySelector('[data-main-image]');
    if (!main) return;
    scope.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        if (src) main.setAttribute('src', src);
        scope.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
      });
    });
  }

  // Quantity steppers
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = parseInt(b.getAttribute('data-step'), 10) || 0;
          var v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = v;
        });
      });
    });
  }

  // Sticky add-to-cart reveals after the product block scrolls past
  function initSticky() {
    var bar = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-product-anchor]');
    if (!bar || !anchor) return;
    window.addEventListener('scroll', function () {
      bar.classList.toggle('show', anchor.getBoundingClientRect().bottom < 0);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    initQty();
    initSticky();
  });
})();
